<section *ngIf="!showEventNarrative">
  <h2>{{title}}</h2>
  <button *ngIf="showEditButton" class="btn btn-active mb-3" (click)="editEvent()" tabindex="0" autofocus>Edit Event</button>
  <error-status *ngIf="displayErrorStatus" [messageTemplate]="errorMessage"></error-status>
  <div class="card">
    <div class="card-body">
      <div class="row gy-2 gx-3 align-items-top m-2" *ngIf="event">
        <div class="col-12">
        </div>
        <div class="col-lg-4 col-md-5">Last Updated:</div>
        <div class="col-lg-8 col-md-7">
          <span *ngIf="event.ModifiedOn; else createdDate">{{ event.ModifiedOn | date:'MM/dd/yyyy' }} at {{ event.ModifiedOn | date:'HH:mm' }} {{ userTimeZone }} by {{ event.ModifiedBy }} </span>
          <ng-template #createdDate><span>{{ event.CreatedOn | date:'MM/dd/yyyy' }} at {{ event.CreatedOn | date:'HH:mm' }} {{ userTimeZone }} by {{ event.CreatedBy }} </span></ng-template>
        </div>
        <div class="col-lg-4 col-md-5">Law enforcement case number:</div>
        <div class="col-lg-8 col-md-7">{{ event.ENESS_XREF_LECaseNumbers?.LECaseNumber }} </div>
        <div class="col-lg-4 col-md-5 ">Alternate law enforcement case number:</div>
        <div class="col-lg-8 col-md-7">{{ event.ENESS_XREF_LECaseNumbers?.LEAlternateCaseNumber }} </div>
        <div class="col-lg-4 col-md-5 ">NIBIN Case &#35;:</div>
        <div class="col-lg-8 col-md-7">{{ event.ENESS_XREF_LECaseNumbers?.NIBINAmendedLECaseNumber }} </div>
        <div class="col-lg-4 col-md-5 ">Date and time event occurred:</div>
        <div class="col-lg-8 col-md-7">{{ event.EventDateOffset | date:'MM/dd/yyyy  HH:mm':event.TimeOffset}} ({{event.ENESS_REF_TimeZone?.TimeZoneName | timeZone}}) </div>
        <div class="col-lg-4 col-md-5 ">Event status:</div>
        <div class="col-lg-8 col-md-7">{{  event.ENESS_REF_Statuses?.Status }} </div>
        <div class="col-lg-4 col-md-5 ">Other status:</div>
        <div class="col-lg-8 col-md-7">{{ event.OtherStatus | sanitizeHtml }} </div>
        <div class="col-lg-4 col-md-5 ">Crime type:</div>
        <div class="col-lg-8 col-md-7">{{ event.ENESS_REF_CrimeTypes?.CrimeTypeName }} </div>
        <div class="col-lg-4 col-md-5 ">Crime type (local terminology):</div>
        <div class="col-lg-8 col-md-7">{{event.OtherCrimeType | shortenText: 80}} </div>
        <div class="col-lg-4 col-md-5 ">Event summary:</div>
        <div class="col-lg-8 col-md-7">{{event.Summary | shortenText: 1000 }} </div>
        <div class="col-lg-4 col-md-5 align-text-top">Event narrative:</div>
        <div class="col-lg-8 col-md-7">{{ event.Narrative | sanitizeHtml }} <ng-container *ngIf="event.Narrative && event.Narrative.length >= 1000"><button type="button" class="btn btn-link" (click)="loadNarrative()">[show full narrative]</button></ng-container></div>
        <div class="col-lg-4 col-md-5 align-text-top">Analyst notes:</div>
        <div class="col-lg-8 col-md-7">{{ event.Notes  | sanitizeHtml }} </div>
        <div class="col-lg-4 col-md-5 ">Agency state:</div>
        <div class="col-lg-8 col-md-7">{{ event.ENESS_REF_Agency?.ENESS_REF_Counties?.ENESS_REF_State?.StateName }} </div>
        <div class="col-lg-4 col-md-5 ">Agency:</div>
        <div class="col-lg-8 col-md-7">{{ event.ENESS_REF_Agency?.AgencyName }} </div>
        <div class="col-lg-4 col-md-5 ">LE partner:</div>
        <div class="col-lg-8 col-md-7">
          <p *ngFor="let partner of event.ENESS_XREF_EventsLEPartners">
            {{partner.ENESS_LEPartner?.FirstName && partner.ENESS_LEPartner?.FirstName.trim()}} {{partner.ENESS_LEPartner?.MiddleName && partner.ENESS_LEPartner?.MiddleName.trim()}} {{partner.ENESS_LEPartner?.LastName && partner.ENESS_LEPartner?.LastName.trim()}}<span *ngIf="partner.PhoneNumber">, Ph. {{partner.PhoneNumber | phoneNumberFormat}}</span>
          </p>
        </div>
        <div class="col-12">
          <div class="table-responsive">
            <table class="temp-bs table table-sm table-striped table-bordered">
              <caption class="caption-top form-label text-body fw-bold">Event locations</caption>
              <thead>
                <tr>
                  <th scope="col">Address</th>
                  <th scope="col">City</th>
                  <th scope="col">State</th>
                  <th scope="col">Postal code</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="!event.ENESS_XREF_EventsLocations || event.ENESS_XREF_EventsLocations.length == 0;else locationrows">
                  <tr>
                    <td colspan="4">No event location found.</td>
                  </tr>
                </ng-container>
                <ng-template #locationrows>
                  <tr *ngFor="let el of event.ENESS_XREF_EventsLocations">
                    <th scope="row">{{ el.StreetAddress }}</th>
                    <td>{{ el.ENESS_Address?.CityName }}</td>
                    <td>{{ el.ENESS_Address?.StateName }}</td>
                    <td>{{ el.ENESS_Address?.PostalCode }}</td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-12">
          <div class="table-responsive">
            <table class="temp-bs table table-sm table-striped table-bordered">
              <caption class="caption-top form-label text-body fw-bold">Event people</caption>
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Date of birth</th>
                  <th scope="col">Sex</th>
                  <th scope="col">Person type</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="!event.ENESS_XREF_EventsPeople || event.ENESS_XREF_EventsPeople.length == 0;else peoplerows">
                  <tr>
                    <td colspan="4">No people found.</td>
                  </tr>
                </ng-container>
                <ng-template #peoplerows>
                  <tr *ngFor="let ep of event.ENESS_XREF_EventsPeople">
                    <th scope="row">{{ ep.ENESS_Person?.FirstName }} {{ ep.ENESS_Person?.LastName }}</th>
                    <td>{{ ep.ENESS_Person?.DateOfBirth | date:"MM/dd/yyyy" }}</td>
                    <td>{{ ep.ENESS_Person?.GenderName }}</td>
                    <td>
                      <ng-container *ngFor="let el of ep.ENESS_XREF_EventsPeopleTypes">{{ el.ENESS_REF_PersonTypes?.PersonTypeName }}<br /></ng-container>
                    </td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-12">
          <div class="table-responsive">
            <table class="temp-bs table table-sm table-striped table-bordered">
              <caption class="caption-top form-label text-body fw-bold">Event attachments</caption>
              <thead>
                <tr>
                  <th scope="col">File Name</th>
                  <th scope="col" class="text-nowrap">Created by</th>
                  <th scope="col" class="text-nowrap">Date</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="!event.ENESS_XREF_EventAttachments || event.ENESS_XREF_EventAttachments.length == 0;else attrows">
                  <tr>
                    <td colspan="3">No attachment found.</td>
                  </tr>
                </ng-container>
                <ng-template #attrows>
                  <tr *ngFor="let ep of event.ENESS_XREF_EventAttachments">
                    <th scope="row">
                      <a tabindex="0" class="download-link" title="Download attachment file" (click)="onClickDownload(ep)">{{ep.ENESS_EventAttachments?.FileName}}</a>
                    </th>
                    <td>{{ ep.ENESS_EventAttachments?.CreatedBy }}</td>
                    <td>{{ ep.ENESS_EventAttachments?.CreatedOn | date:"MM/dd/yyyy" }}</td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>  </div>
  <button type="button" (click)="showEventDetail.emit(false)" class="btn btn-active my-3">Close</button>
</section>
<section *ngIf="showEventNarrative && (eventNarrative$ | async)" class="m-3">
  <h2>Narrative for {{ eventNarrative.LECaseNumber }}</h2>
  <p>{{ eventNarrative.Narrative }}</p>
  <div>
    <button type="button" (click)="showEventNarrative = false;eventNarrative = {};" class="btn btn-active my-3">Close</button>
  </div>
</section>

